import * as REDUX_TYPES from '../types'
import { CATEGORY_MODES } from './harmonizeReducer'

const INITIAL_STATE = {
    categoryMode: CATEGORY_MODES.ALL_MEDIA,
    fetchInProgress: false,
    fetchStart: 0,
    query: undefined,
    refetchMessageId: null, //If defined get this Message from Social Service and update messages and playList
}


const fetchReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {


        case REDUX_TYPES.FETCH.CATEGORY_MODE:
            return {
                ...state,
                categoryMode: action.categoryMode,
            }

        case REDUX_TYPES.FETCH.FETCH_IN_PROGRESS:

            return {
                ...state,
                fetchInProgress: action.fetchInProgress,
            }
        case REDUX_TYPES.FETCH.FETCH_START:

            return {
                ...state,
                fetchStart: action.fetchStart,
            }

        case REDUX_TYPES.FETCH.QUERY:
            return {
                ...state,
                query: action.query,
            }
        case REDUX_TYPES.FETCH.REFETCH_MESSAGE_ID:
            return {
                ...state,
                refetchMessageId: action.refetchMessageId,
            }


        default:
            return state
    }
}
export default fetchReducer